<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col span="5">
            <a-form-model-item label="设备类型">
              <j-tree-select-custom
                @change="devClassChange"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8" :xs="24">
            <a-form-model-item label="缺陷等级">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="def_level"
                placeholder="请选择"
                type="checkbox"
                v-model="queryParam.defLevel"
              ></j-multi-select-tag>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :lg="8" :md="8" :sm="24" :xl="8" :xs="24">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>-->
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('缺陷标准库')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="defType" slot-scope="defType, record">
          <span v-if="record.defType==1">
            <a-tag>设备类型</a-tag>
          </span>
          <span v-else-if="record.defType==2">
            <a-tag>非设备类型</a-tag>
          </span>
        </span>
        <span slot="defLevel" slot-scope="priority, record">
          <a-tag :color="$filterDictTextByCache('def_level_color', record.defLevel)">{{record.defLevel_dictText}}</a-tag>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <def-standard-modal :devClassList="devClassList" @ok="modalFormOk" ref="modalForm"></def-standard-modal>
  </a-card>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DefStandardModal from './modules/DefStandardModal'

  export default {
    name: 'DefStandardList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DefStandardModal
    },
    data () {
      return {
        devClassList: [],
        description: '缺陷标准库管理页面',
        // 表头
        columns: [
          {
            title: '缺陷类型',
            align: "center",
            dataIndex: 'defType',
            scopedSlots: { customRender: 'defType' },
            sorter: true,
          },
          {
            title: '设备类型',
            align: "center",
            dataIndex: 'devClassName',
            sorter: true,
          },
          {
            title: '缺陷部位',
            align: "center",
            dataIndex: 'defPart',
            sorter: true,
          },
          {
            title: '缺陷类别',
            align: "center",
            dataIndex: 'defCategory',
            sorter: true,
          },
          {
            title: '缺陷描述',
            align: "center",
            dataIndex: 'remarks',
            sorter: true,
          },
          {
            title: '缺陷等级',
            align: "center",
            dataIndex: 'defLevel',
            scopedSlots: { customRender: 'defLevel' },
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/device/defStandard/list",
          delete: "/device/defStandard/delete",
          deleteBatch: "/device/defStandard/deleteBatch",
          exportXlsUrl: "/device/defStandard/exportXls",
          importExcelUrl: "device/defStandard/importExcel",
          selectClass: '/device/devClass/selectDropList'
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList()
      this.getClassList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      devClassChange (devClassCode) {
        this.queryParam.devClassCode = devClassCode ? devClassCode + '*' : null;
        this.searchQuery();
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'defType', text: '缺陷类型(设备类/非设备类)', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devClassName', text: '设备类型名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defPart', text: '缺陷部位', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defCategory', text: '缺陷类别', dictCode: '' })
        fieldList.push({ type: 'string', value: 'remarks', text: '缺陷描述', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defLevel', text: '缺陷等级', dictCode: '' })
        this.superFieldList = fieldList
      },
      getClassList () {
        getAction(this.url.selectClass, {}).then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>